@if (showBackButton) {
  <div class="inner-navigation">
    <div class="back" (click)="navigateBack()">
      <p class="text-button-small">{{ 'edit-pet-info.back-button-text' | translate }}</p>
    </div>
  </div>
}

<div class="page-title">
  <div class="title">
    @if (!this.isPetNameAvailable()) {
      <h3>{{ 'edit-pet-info.page-title-no-name' | translate }}</h3>
    }
    @if (this.isPetNameAvailable()) {
      <h3
      >{{ 'edit-pet-info.page-title' | translate: { petName: form.getRawValue().petName } }}</h3>
    }
  </div>
</div>

<div class="form" [formGroup]="form">
  <div class="row">
    <div class="image-input-container">
      <input
        class="image-input"
        type="file"
        [accept]="'image/*'"
        (change)="onFileChange($event)"
        #fileInput
        [multiple]="false"/>
        <div class="image-container" (click)="fileInput.click()">
          @if (petPicture) {
            <img class="image" [src]="petPicture" alt="pet-picture">
          }
          @if (!petPictureSet) {
            <div class="plus-overlay">
              <img class="no-image" src="assets/add_round_fill.svg" alt="no-image"/>
            </div>
          }
          @if (petPictureSet) {
            <div class="edit-overlay" (click)="$event.stopPropagation(); fileInput.click()"><img
            src="assets/edit_pencil_fill.svg" alt="edit"></div>
          }
        </div>
      </div>
    </div>

    <div class="row disabled-row">
      <div class="title">
        <p class="subtitle-14">{{ 'edit-pet-info.form.pet-name-label' | translate }}</p>
      </div>

      <div class="input">
        <input
          class="input"
          type="text"
          [placeholder]="'edit-pet-info.form.pet-name-placeholder' | translate"
          formControlName="petName"/>
        </div>
      </div>

      <div class="row disabled-row">
        <div class="title">
          @if (this.isPetNameAvailable()) {
            <p
            class="subtitle-14">{{ 'edit-pet-info.form.species-label' | translate: { petName: form.getRawValue().petName } }}</p>
          }
          @if (!this.isPetNameAvailable()) {
            <p
            class="subtitle-14">{{ 'edit-pet-info.form.species-label-no-name' | translate }}</p>
          }
        </div>

        <div class="inline-select">
          <label for="cat" [class.selected]="form.getRawValue().species==='cat'">
            <input id="cat" type="radio" value="cat" formControlName="species">
            <span>{{ 'edit-pet-info.form.species-cat' | translate }}</span>
          </label>

          <label for="dog" [class.selected]="form.getRawValue().species==='dog'">
            <input id="dog" type="radio" value="dog" formControlName="species">
            <span>{{ 'edit-pet-info.form.species-dog' | translate }}</span>
          </label>
        </div>
      </div>

      <div class="row disabled-row">
        <div class="title">
          @if (this.isPetNameAvailable()) {
            <p
            class="subtitle-14">{{ 'edit-pet-info.form.gender-label' | translate : { petName: form.getRawValue().petName } }}</p>
          }
          @if (!this.isPetNameAvailable()) {
            <p
            class="subtitle-14">{{ 'edit-pet-info.form.gender-label-no-name' | translate }}</p>
          }
        </div>

        <div class="inline-select">
          <label for="male" [class.selected]="form.getRawValue().petGender==='male'">
            <input id="male" type="radio" value="male" formControlName="petGender">
            <span>{{ 'edit-pet-info.form.gender-male' | translate }}</span>
          </label>

          <label for="female" [class.selected]="form.getRawValue().petGender==='female'">
            <input id="female" type="radio" value="female" formControlName="petGender">
            <span>{{ 'edit-pet-info.form.gender-female' | translate }}</span>
          </label>
        </div>
      </div>

      <div class="row disabled-row">
        <div class="title">
          @if (this.isPetNameAvailable()) {
            <p
            class="subtitle-14">{{ 'edit-pet-info.form.pedigree-label' | translate : { petName: form.getRawValue().petName } }}</p>
          }
          @if (!this.isPetNameAvailable()) {
            <p
            class="subtitle-14">{{ 'edit-pet-info.form.pedigree-label-no-name' | translate }}</p>
          }
        </div>

        <div class="inline-select">
          <label for="pedigree" [class.selected]="form.getRawValue().pedigree==='pedigree'">
            <input id="pedigree" type="radio" value="pedigree" formControlName="pedigree">
            <span>{{ 'edit-pet-info.form.pedigree-pedigree' | translate }}</span>
          </label>

          <label for="cross" [class.selected]="form.getRawValue().pedigree==='cross'">
            <input id="cross" type="radio" value="cross" formControlName="pedigree">
            <span>{{ 'edit-pet-info.form.pedigree-cross' | translate }}</span>
          </label>

          <label for="mixed" [class.selected]="form.getRawValue().pedigree==='mixed'">
            <input id="mixed" type="radio" value="mixed" formControlName="pedigree">
            <span>{{ 'edit-pet-info.form.pedigree-mixed' | translate }}</span>
          </label>
        </div>
      </div>

      @if (showBreedSelector()) {
        <div class="row disabled-row">
          <div class="title">
            @if (this.isPetNameAvailable()) {
              <p
              class="subtitle-14">{{ 'edit-pet-info.form.breed-label' | translate: { petName: form.getRawValue().petName } }}</p>
            }
            @if (!this.isPetNameAvailable()) {
              <p
              class="subtitle-14">{{ 'edit-pet-info.form.breed-label-no-name' | translate }}</p>
            }
          </div>
          <div class="inline-select">
            <mat-select formControlName="breed" class="input">
              <mat-option value="">{{ 'edit-pet-info.form.breed-placeholder' | translate }}</mat-option>
              @for (breed of breeds; track breed) {
                <mat-option [value]="breed.id">{{ breed.name }}</mat-option>
              }
            </mat-select>
          </div>
        </div>
      }

      @if (showTallDogQuestion()) {
        <div class="row disabled-row">
          <div class="title">
            <p class="subtitle-14">{{ 'edit-pet-info.form.tall-dog-label' | translate }}</p>
          </div>
          <div class="inline-select">
            <label for="tall-dog-yes" [class.selected]="form.getRawValue().tallDog">
              <input id="tall-dog-yes" type="radio" [value]="true" formControlName="tallDog">
              <span>{{ 'edit-pet-info.form.yes' | translate }}</span>
            </label>
            <label for="tall-dog-no" [class.selected]="!form.getRawValue().tallDog">
              <input id="tall-dog-no" type="radio" [value]="false" formControlName="tallDog">
              <span>{{ 'edit-pet-info.form.no' | translate }}</span>
            </label>
          </div>
        </div>
      }

      @if (showHouseCatQuestion()) {
        <div class="row">
          <div class="title">
            <p
            class="subtitle-14">{{ 'edit-pet-info.form.house-cat-label' | translate: { petName: form.getRawValue().petName } }}</p>
          </div>
          <div class="inline-select">
            <!--  Need to reverse the text on button, because lable text question is more like "Is cat allow outside".  When user select 'yes' it means cat is NOT housecat.    -->
            <label for="house-cat-no" [class.selected]="!form.getRawValue().housecat">
              <input id="house-cat-no" type="radio" [value]="false" formControlName="housecat">
              <span>{{ 'edit-pet-info.form.yes' | translate }}</span>
            </label>
            <label for="house-cat-yes" [class.selected]="form.getRawValue().housecat">
              <input id="house-cat-yes" type="radio" [value]="true" formControlName="housecat">
              <span>{{ 'edit-pet-info.form.no' | translate }}</span>
            </label>
          </div>
        </div>
      }

      <div class="row form-field disabled-row">
        <div class="title">
          @if (this.isPetNameAvailable()) {
            <p
            class="subtitle-14">{{ 'edit-pet-info.form.pet-birthdate-label' | translate: { petName: form.getRawValue().petName } }}</p>
          }
          @if (!this.isPetNameAvailable()) {
            <p
            class="subtitle-14">{{ 'edit-pet-info.form.pet-birthdate-label-no-name' | translate }}</p>
          }
        </div>

        <div class="input">
          <div class="form-field-date">
            <input matInput
              class="input"
              [matDatepicker]="petBirthDateField"
              (click)="petBirthDateField.open()"
              [max]="maxPetBirthdate()"
              formControlName="petBirthDate">
              <mat-datepicker-toggle matSuffix [for]="petBirthDateField"></mat-datepicker-toggle>
              <mat-datepicker #petBirthDateField></mat-datepicker>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="title">
            @if (this.isPetNameAvailable()) {
              <p
              class="subtitle-14">{{ 'edit-pet-info.form.neutered-label' | translate: { petName: form.getRawValue().petName } }}</p>
            }
            @if (!this.isPetNameAvailable()) {
              <p
              class="subtitle-14">{{ 'edit-pet-info.form.neutered-label-no-name' | translate }}</p>
            }
          </div>

          <div class="inline-select">
            <label for="neutered-yes" [class.selected]="form.getRawValue().neutered">
              <input id="neutered-yes" type="radio" [value]="true" formControlName="neutered">
              <span>{{ 'edit-pet-info.form.yes' | translate }}</span>
            </label>

            <label for="neutered-no" [class.selected]="!form.getRawValue().neutered">
              <input id="neutered-no" type="radio" [value]="false" formControlName="neutered">
              <span>{{ 'edit-pet-info.form.no' | translate }}</span>
            </label>
          </div>
        </div>

        <div class="actions">
          <button class="button primary" [disabled]="!isFormChanged()" (click)="saveChanges()">
            {{ 'edit-pet-info.form.save-button' | translate }}
          </button>
        </div>
      </div>
